export const openEmailLink = ()=>{
	window.location.href = [
		'mail', 'to', ':',
		'carlosanaya01.contacto', '@', 'gmail', '.', 'com',
		'?subject=Hi!'
	].join('')
}
